import { render, staticRenderFns } from "./KeywordMovement.vue?vue&type=template&id=237799c4&"
import script from "./KeywordMovement.vue?vue&type=script&lang=js&"
export * from "./KeywordMovement.vue?vue&type=script&lang=js&"
import style0 from "./KeywordMovement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports